const heroSliderBlocks = document.querySelectorAll('.block-hero-slider');
const heroSliderBlockObjects = [];
let isMobile = window.innerWidth < 1024;

/**
 * Initialize hero slider blocks.
 *
 * @return {void}
 */
const initHeroSliderBlocks = () => {
	heroSliderBlocks?.forEach((block, blockIndex) => {
		const contentSlidesContainer = block.querySelector(
			'.block-hero-slider__content-slides'
		);
		const contentSlides = block.querySelectorAll(
			'.block-hero-slider__content-slide'
		);
		const imageSlidesContainer = block.querySelector(
			'.block-hero-slider__image-slides'
		);
		const imageSlides = block.querySelectorAll(
			'.block-hero-slider__image-slide'
		);
		const imageSlidesTrack = block.querySelector(
			'.block-hero-slider__image-slides-track'
		);
		const smImageSlides = block.querySelectorAll(
			'.block-hero-slider__image-slide-small'
		);
		const cardSlides = block.querySelectorAll(
			'.block-hero-slider__card-slide:not(.block-hero-slider__card-slide--mobile)'
		);
		// const cardSlidesMobile = block.querySelectorAll(
		// 	'.block-hero-slider__card-slide.block-hero-slider__card-slide--mobile'
		// );

		const cardSlidesMobile = block.querySelectorAll(
			'.block-hero-slider__card-slide--mobile'
		);
		// const cardSlidesDesktop = block.querySelectorAll(
		// 	'.block-hero-slider__card-slide--desktop'
		// );

		const mobilePaginationOverlines = block.querySelectorAll(
			'.block-hero-slider__mobile-arrows-label'
		);
		const paginationButtons = block.querySelectorAll(
			'.block-hero-slider__pagination-button'
		);
		const prevArrow = block.querySelector(
			'.block-hero-slider__arrow--prev'
		);
		const nextArrow = block.querySelector(
			'.block-hero-slider__arrow--next'
		);
		// Helper: add both click and touchend event listeners
		const addClickAndTouch = (el, handler) => {
			if (!el) return;
			el.addEventListener('click', handler);
			el.addEventListener('touchend', function (e) {
				// Prevent duplicate event on iOS
				e.preventDefault();
				handler(e);
			});
		};
		const currentInd = 0;
		const autoSlideDuration = 5000;

		heroSliderBlockObjects.push({
			block,
			contentSlidesContainer,
			contentSlides,
			imageSlidesContainer,
			imageSlides,
			imageSlidesTrack,
			smImageSlides,
			cardSlides,
			cardSlidesMobile,
			paginationButtons,
			mobilePaginationOverlines,
			currentInd,
			totalSlides: contentSlides.length,
			isTransitioning: false,
			isAutoSliding: true,
			mobileInitialized: isMobile,
			autoSlideDuration,
		});

		// Set mobile video poster image
		if (isMobile) {
			imageSlides.forEach((slide) => {
				const video = slide.querySelector('video');
				if (video) {
					setVideoPoster(video);
				}
			});
		} else {
			// Play video on the first visible slide (desktop only)
			const firstSlide = block.querySelector(
				'.block-hero-slider__image-slide[aria-hidden="false"]'
			);
			if (firstSlide) {
				const video = firstSlide.querySelector('video');

				if (video) {
					toggleVideo(video, false);
				}
			}
		}

		// Start auto sliding
		initializeAutoSliding(blockIndex);

		// Add auto sliding data attribute
		block.setAttribute('data-auto-sliding', 'true');

		// Start animating pagination button progress bar
		updateActivePaginationButton(
			blockIndex,
			heroSliderBlockObjects[blockIndex].currentInd
		);

		block.style.setProperty(
			'--auto-slide-duration',
			autoSlideDuration + 'ms'
		);

		setContentSlidesHeight(blockIndex);

		block.classList.add('initialized');

		updateAriaHiddenForHeaders(block);

		paginationButtons?.forEach((button, index) => {
			addClickAndTouch(button, () => {
				heroSliderBlockObjects[blockIndex].isAutoSliding = false;
				if (heroSliderBlockObjects[blockIndex].autoSlideRequestId) {
					cancelAnimationFrame(
						heroSliderBlockObjects[blockIndex].autoSlideRequestId
					);
					heroSliderBlockObjects[blockIndex].autoSlideRequestId =
						null;
				}
				block.setAttribute('data-auto-sliding', 'false');
				heroSliderChangeSlide(blockIndex, index);
			});
		});

		addClickAndTouch(prevArrow, () => {
			heroSliderBlockObjects[blockIndex].isAutoSliding = false;
			if (heroSliderBlockObjects[blockIndex].autoSlideRequestId) {
				cancelAnimationFrame(
					heroSliderBlockObjects[blockIndex].autoSlideRequestId
				);
				heroSliderBlockObjects[blockIndex].autoSlideRequestId = null;
			}
			block.setAttribute('data-auto-sliding', 'false');
			let prevSlide = heroSliderBlockObjects[blockIndex].currentInd - 1;
			if (prevSlide < 0) {
				prevSlide = heroSliderBlockObjects[blockIndex].totalSlides - 1;
			}
			heroSliderChangeSlide(blockIndex, prevSlide);
		});

		addClickAndTouch(nextArrow, () => {
			heroSliderBlockObjects[blockIndex].isAutoSliding = false;
			if (heroSliderBlockObjects[blockIndex].autoSlideRequestId) {
				cancelAnimationFrame(
					heroSliderBlockObjects[blockIndex].autoSlideRequestId
				);
				heroSliderBlockObjects[blockIndex].autoSlideRequestId = null;
			}
			block.setAttribute('data-auto-sliding', 'false');
			let nextSlide = heroSliderBlockObjects[blockIndex].currentInd + 1;
			if (nextSlide >= heroSliderBlockObjects[blockIndex].totalSlides) {
				nextSlide = 0;
			}
			heroSliderChangeSlide(blockIndex, nextSlide);
		});
	});
};

/**
 * Initialize auto sliding for a specific hero slider block.
 *
 * @param {number} blockIndex - The index of the block to initialize auto sliding for.
 * @return {void}
 */
const initializeAutoSliding = (blockIndex) => {
	// Cancel any previous animation frame
	if (heroSliderBlockObjects[blockIndex].autoSlideRequestId) {
		cancelAnimationFrame(
			heroSliderBlockObjects[blockIndex].autoSlideRequestId
		);
		heroSliderBlockObjects[blockIndex].autoSlideRequestId = null;
	}

	// Set last slide time to now if not set
	if (!heroSliderBlockObjects[blockIndex].lastSlideTime) {
		heroSliderBlockObjects[blockIndex].lastSlideTime = Date.now();
	}

	const autoSlideLoop = () => {
		const blockObj = heroSliderBlockObjects[blockIndex];
		if (!blockObj.isAutoSliding) {
			blockObj.autoSlideRequestId = null;
			return; // Stop if auto sliding is disabled
		}
		const now = Date.now();
		if (now - blockObj.lastSlideTime >= blockObj.autoSlideDuration) {
			let nextSlide = blockObj.currentInd + 1;
			if (nextSlide >= blockObj.totalSlides) {
				nextSlide = 0;
			}
			heroSliderChangeSlide(blockIndex, nextSlide);
			blockObj.lastSlideTime = now;
		}
		blockObj.autoSlideRequestId = requestAnimationFrame(autoSlideLoop);
	};

	heroSliderBlockObjects[blockIndex].autoSlideRequestId =
		requestAnimationFrame(autoSlideLoop);
};

/**
 * Set the height of content slides for a specific hero slider block.
 *
 * @param {number} blockIndex - The index of the block to set the content slides height for.
 * @return {void}
 */
const setContentSlidesHeight = (blockIndex) => {
	const block = heroSliderBlockObjects[blockIndex].block;
	const contentSlidesContainer =
		heroSliderBlockObjects[blockIndex].contentSlidesContainer;
	const contentSlides = heroSliderBlockObjects[blockIndex].contentSlides;
	let contentMaxHeight = 0;

	if (contentSlidesContainer && contentSlides.length) {
		contentSlides.forEach((slide) => {
			const slideHeight = slide.offsetHeight;
			if (slideHeight > contentMaxHeight) {
				contentMaxHeight = slideHeight;
			}
		});

		block.style.setProperty('--content-height', contentMaxHeight + 'px');
	}
};

/**
 * Change the slide in the hero slider block.
 *
 * @param {number} blockIndex - The index of the block to change the slide for.
 * @param {number} newIndex   - The index of the new slide to show.
 * @return {void}
 */
const heroSliderChangeSlide = (blockIndex, newIndex) => {
	const block = heroSliderBlockObjects[blockIndex];
	const { currentInd, totalSlides, isTransitioning } = block;

	if (isTransitioning || newIndex === currentInd) {
		return;
	}
	block.isTransitioning = true;

	// Helper to get a slide by class and data-key
	const getSlideByKey = (nodeList, key) =>
		Array.from(nodeList).find(
			(el) => el.getAttribute('data-key') === String(key)
		);

	// Helper to build a transition element if the slide exists
	const buildTransEle = (el, isCurrentSlide) =>
		el ? { el, isCurrentSlide } : null;

	// Collect all possible transition elements
	const transitionCandidates = [
		buildTransEle(getSlideByKey(block.contentSlides, currentInd), true),
		buildTransEle(getSlideByKey(block.smImageSlides, currentInd), true),
		buildTransEle(getSlideByKey(block.contentSlides, newIndex), false),
		buildTransEle(getSlideByKey(block.smImageSlides, newIndex), false),
	];

	if (!isMobile) {
		transitionCandidates.push(
			buildTransEle(getSlideByKey(block.imageSlides, currentInd), true),
			buildTransEle(getSlideByKey(block.imageSlides, newIndex), false),
			buildTransEle(getSlideByKey(block.cardSlides, currentInd), true),
			buildTransEle(getSlideByKey(block.cardSlides, newIndex), false)
		);
	} else {
		transitionCandidates.push(
			buildTransEle(
				getSlideByKey(block.cardSlidesMobile, currentInd),
				true
			),
			buildTransEle(
				getSlideByKey(block.cardSlidesMobile, newIndex),
				false
			)
		);
	}

	// Filter out nulls and unwanted small image slides on tablet/mobile
	const transitionElements = transitionCandidates.filter((item) => {
		if (
			item &&
			item.el &&
			window.innerWidth < 1024 &&
			item.el.classList.contains('block-hero-slider__image-slide-small')
		) {
			return false;
		}
		return item && !!item.el;
	});

	// Update active progress bar animation
	updateActivePaginationButton(blockIndex, newIndex);

	// Update mobile card slide elements since these do not transition
	if (isMobile) {
		block.cardSlides.forEach((slide, index) => {
			if (index === newIndex) {
				slide.setAttribute('aria-hidden', 'false');
			} else {
				slide.setAttribute('aria-hidden', 'true');
			}
		});

		block.imageSlides.forEach((slide, index) => {
			const isCurrentSlide = index === newIndex;
			slide.setAttribute(
				'aria-hidden',
				isCurrentSlide ? 'false' : 'true'
			);
		});
		block.mobilePaginationOverlines.forEach((slide, index) => {
			const isCurrentSlide = index === newIndex;
			slide.setAttribute(
				'aria-hidden',
				isCurrentSlide ? 'false' : 'true'
			);
		});
	}

	// Start transitions by adding appropriate classes
	transitionElements.forEach(({ el, isCurrentSlide }) => {
		if (isCurrentSlide) {
			el?.classList.add('transition-out');
		} else {
			el?.classList.add('transition-in');
		}
	});

	// Wait for all transitions to complete to update states
	waitForTransitions(transitionElements).then(() => {
		block.isTransitioning = false;

		// Loop through all transitioned elements and update their aria-hidden and classes
		transitionElements.forEach(({ el, isCurrentSlide }) => {
			el.setAttribute('aria-hidden', isCurrentSlide ? 'true' : 'false');
			el.classList.remove(
				isCurrentSlide ? 'transition-out' : 'transition-in'
			);

			// Play/pause video if present
			if (!isMobile) {
				const video = el.querySelector('video');
				if (video) {
					toggleVideo(video, isCurrentSlide);
				}
			}
		});

		// Increment current slide count index
		block.currentInd = newIndex;
		if (block.currentInd >= totalSlides) {
			block.currentInd = 0;
		}
	});
};

/**
 * Wait for CSS transitions to complete on transitioned elements.
 *
 * @param {NodeList} elements - List of elements to monitor for transitions.
 * @param {string}   property - CSS property to listen for transition end (default: 'opacity').
 * @return {Promise} Promise that resolves when all transitions complete.
 */
/**
 * Wait for CSS transitions to complete on transitioned elements.
 * Listens for 'opacity' and/or 'transform' property transitions.
 *
 * @param {Array}           elements   - Array of elements to monitor for transitions.
 * @param {string|string[]} properties - CSS property/properties to listen for (default: ['opacity', 'transform']).
 * @return {Promise} Promise that resolves when all transitions complete.
 */
const waitForTransitions = (
	elements,
	properties = ['opacity', 'transform']
) => {
	// Support string or array for properties
	const props = Array.isArray(properties) ? properties : [properties];
	return new Promise((resolve) => {
		let remaining = elements.length;

		function handler(e) {
			if (props.includes(e.propertyName)) {
				e.target.removeEventListener('transitionend', handler);
				remaining--;
				if (remaining === 0) {
					resolve();
				}
			}
		}

		elements.forEach((el) => {
			el.el?.addEventListener('transitionend', handler);
		});
	});
};

/**
 * Set the active pagination button for the hero slider.
 *
 * @param {number} blockIndex
 * @param {number} newIndex
 * @return {void}
 */
const updateActivePaginationButton = (blockIndex, newIndex) => {
	const { paginationButtons } = heroSliderBlockObjects[blockIndex];
	paginationButtons.forEach((button, index) => {
		button.classList.toggle('active', index === newIndex);
	});
};

/**
 * Toggle video play/pause and load source if needed.
 *
 * @param {HTMLVideoElement} video
 * @param {boolean}          isCurrentSlide
 */
const toggleVideo = (video, isCurrentSlide) => {
	const source = video.querySelector('source');
	const src = source?.getAttribute('src');
	const dataSrc = source?.getAttribute('data-src');

	// Add src and load video for the first time
	if (source && !src && dataSrc) {
		source.src = dataSrc;
		video.load();
	}

	// Play/pause video
	if (isCurrentSlide) {
		video.pause();
	} else {
		video.play();
	}
};

/**
 * Set the video poster based on device type.
 *
 * @param {HTMLVideoElement} video
 */
const setVideoPoster = (video) => {
	const desktopPosterSrc = video.getAttribute('data-desktop-poster');
	const mobilePosterSrc = video.getAttribute('data-mobile-poster');
	video.setAttribute(
		'poster',
		isMobile && mobilePosterSrc ? mobilePosterSrc : desktopPosterSrc
	);
};

/**
 * Updates aria-hidden attributes for desktop and mobile header/description elements
 * within a hero slider block based on the current viewport size.
 * Ensures only visible content is accessible to screen readers for accessibility compliance.
 *
 * Called on slider initialization and window resize.
 *
 * @param {HTMLElement} block - The hero slider block element to update.
 * @return {void}
 */
function updateAriaHiddenForHeaders(block) {
	const isMobileView = window.innerWidth < 1024;
	const desktopHeaders = block.querySelectorAll(
		'.block-hero-slider__content-slide-header--desktop'
	);
	const mobileHeaders = block.querySelectorAll(
		'.block-hero-slider__content-slide-header--mobile'
	);
	const desktopDescriptions = block.querySelectorAll(
		'.block-hero-slider__content-slide-description--desktop'
	);
	const mobileDescriptions = block.querySelectorAll(
		'.block-hero-slider__content-slide-description--mobile'
	);

	if (isMobileView) {
		// Mobile: show mobile, hide desktop
		desktopHeaders.forEach((el) => el.setAttribute('aria-hidden', 'true'));
		mobileHeaders.forEach((el) => el.setAttribute('aria-hidden', 'false'));
		desktopDescriptions.forEach((el) =>
			el.setAttribute('aria-hidden', 'true')
		);
		mobileDescriptions.forEach((el) =>
			el.setAttribute('aria-hidden', 'false')
		);
	} else {
		// Desktop: show desktop, hide mobile
		desktopHeaders.forEach((el) => el.setAttribute('aria-hidden', 'false'));
		mobileHeaders.forEach((el) => el.setAttribute('aria-hidden', 'true'));
		desktopDescriptions.forEach((el) =>
			el.setAttribute('aria-hidden', 'false')
		);
		mobileDescriptions.forEach((el) =>
			el.setAttribute('aria-hidden', 'true')
		);
	}
}

/**
 * Update hero slider blocks on window resize.
 *
 * @return {void}
 */
const updateOnResize = () => {
	isMobile = window.innerWidth < 1024;

	heroSliderBlockObjects?.forEach((obj, blockIndex) => {
		updateAriaHiddenForHeaders(obj.block);
		if (
			(isMobile && !obj.mobileInitialized) ||
			(!isMobile && obj.mobileInitialized)
		) {
			obj.currentInd = 0;
			obj.mobileInitialized = !obj.mobileInitialized;

			// Reset slide elements to beginning
			const resetSlideElements = (slides) => {
				slides.forEach((slide, index) => {
					const video = slide.querySelector('video');

					if (video) {
						video.pause();
						video.removeAttribute('src');
						video.load();
						setVideoPoster(video);
					}

					if (
						slide.classList.contains(
							'block-hero-slider__pagination-button'
						)
					) {
						updateActivePaginationButton(blockIndex, 0);
					} else {
						slide.setAttribute(
							'aria-hidden',
							index === 0 ? 'false' : 'true'
						);
					}
				});
			};

			resetSlideElements(obj.contentSlides);
			resetSlideElements(obj.imageSlides);
			resetSlideElements(obj.smImageSlides);
			resetSlideElements(obj.paginationButtons);

			// Find the visible image slide's data-key (should be 0 after reset)
			const visibleImageSlide = obj.block.querySelector(
				'.block-hero-slider__image-slide[aria-hidden="false"]'
			);
			const visibleKey = visibleImageSlide
				? visibleImageSlide.getAttribute('data-key')
				: '0';

			// Set aria-hidden on card slides based on data-key match
			obj.cardSlides.forEach((slide) => {
				const cardKey = slide.getAttribute('data-key');
				slide.setAttribute(
					'aria-hidden',
					cardKey === visibleKey ? 'false' : 'true'
				);
			});

			// Remove transition-in and transition-out from all card and image slides after resize
			const allCardSlides = obj.block.querySelectorAll(
				'.block-hero-slider__card-slide'
			);
			const allImageSlides = obj.block.querySelectorAll(
				'.block-hero-slider__image-slide'
			);
			allCardSlides.forEach((slide) => {
				slide.classList.remove('transition-in', 'transition-out');
			});
			allImageSlides.forEach((slide) => {
				slide.classList.remove('transition-in', 'transition-out');
			});
		}

		// Reset last slide time so auto sliding and progress bar are in sync
		heroSliderBlockObjects[blockIndex].lastSlideTime = Date.now();
		initializeAutoSliding(blockIndex);

		// Update content slides height
		setContentSlidesHeight(blockIndex);
	});
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initHeroSliderBlocks();
	},
	loaded() {},
	resized() {
		updateOnResize();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
